export function getCommissionStartTimestamp(commission) {
  if (!commission || commission.start === null || commission.start === undefined || commission.start === '') {
    return null;
  }

  const timestamp = Number(commission.start);
  return Number.isFinite(timestamp) ? timestamp : null;
}

export function isCommissionSelectable(commission, now = Date.now()) {
  const start = getCommissionStartTimestamp(commission);
  return Boolean(commission) && (start === null || start <= now);
}
